<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!nuveiCard">
      <span class="loader"></span>
    </span>
    <nuvei-card-form
      v-if="nuveiCard"
      :loading="loading"
      :nuveiCardData="nuveiCard"
      :formErrors="formErrors"
      @nuveiCardSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import NuveiCardForm from "../partials/NuveiCardForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { NuveiCardForm },

  mixins: [alertLeave],

  props: {
    nuveiCardId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      nuveiCard: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("nuveiCards/get", this.nuveiCardId);
        this.nuveiCard = this.$store.getters["nuveiCards/nuveiCard"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(nuveiCard) {
      this.loading = true;
      const nuveiCardData = cloneDeep(nuveiCard);

      try {
        await this.$store.dispatch("nuveiCards/update", nuveiCardData);
        this.$notify({
          type: "success",
          message: this.$t("NUVEI_CARDS.NUVEI_CARD_UPDATED"),
        });
        const nuveiCard = await this.$store.getters["nuveiCards/nuveiCard"];
        this.$emit("onViewNuveiCard", nuveiCard, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
